import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

// props
interface IProps {
	value?: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPrice',
  props: {
    value: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	value?: any;
};



// computed
const isInvalid = computed<boolean>(() => price.value <= 0);

// data
const price = ref<number>(props.value ?? 0);

// expose
expose({ isInvalid });

return { __sfc: true,props, isInvalid, price }
}

})